import { render, staticRenderFns } from "./BpPageNav.vue?vue&type=template&id=708a6029&"
import script from "./BpPageNav.vue?vue&type=script&lang=js&"
export * from "./BpPageNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports